(function () {
  // Ensure jQuery is available
  if (typeof window.jQuery === 'undefined') {
    console.error('jQuery is not loaded. custom.js will not run.');
    return;
  }

  var $ = window.jQuery;
  console.log('✅ custom.js is loaded');

  // -----------------------------
  // Better Price: renderButton interceptor (product pages only)
  // -----------------------------
  if (/\/products\//.test(window.location.pathname)) {
    (function installRenderButtonInterceptor() {
      function ensureWrapper() {
        var wrapper = document.getElementById('betterPriceWrapper');
        if (!wrapper) {
          var pricebeater = document.querySelector('.pricebeater') || document.body;
          wrapper = document.createElement('div');
          wrapper.id = 'betterPriceWrapper';
          wrapper.style.backgroundColor = 'transparent';
          wrapper.style.color = 'white';
          wrapper.style.fontSize = '10px';
          wrapper.style.fontWeight = 'bold';
          wrapper.style.cursor = 'pointer';
          wrapper.style.width = '300px';
          pricebeater.appendChild(wrapper);
          console.log('✅ #betterPriceWrapper injected just-in-time');
        }
      }

      function wrap(fn) {
        return function () {
          try { ensureWrapper(); } catch (_) {}
          return fn.apply(this, arguments);
        };
      }

      var wrapped = false;

      // Case 1: renderButton already defined
      if (typeof window.renderButton === 'function') {
        window.renderButton = wrap(window.renderButton);
        wrapped = true;
      }

      // Case 2: renderButton will be defined later — intercept setter
      if (!wrapped) {
        try {
          Object.defineProperty(window, 'renderButton', {
            configurable: true,
            get: function () { return undefined; },
            set: function (fn) {
              var w = wrap(fn);
              Object.defineProperty(window, 'renderButton', {
                configurable: true,
                writable: true,
                value: w
              });
            }
          });
        } catch (e) {
          // Fallback: poll briefly until it appears
          var tries = 0, max = 50;
          var timer = setInterval(function () {
            if (typeof window.renderButton === 'function') {
              window.renderButton = wrap(window.renderButton);
              clearInterval(timer);
            } else if (++tries >= max) {
              clearInterval(timer);
            }
          }, 100);
        }
      }
    })();
  }

  // -----------------------------
  // Navigation dropdown offset helper (safe + independent of theme internals)
  // -----------------------------
  (function () {
    function getDropdowns() {
      return $('#AccessibleNav').find('[data-meganav-dropdown]');
    }

    function updateDropdownOffsets() {
      var $dropdowns = getDropdowns();
      if (!$dropdowns.length) return;

      var viewport = $(window).width();
      $dropdowns
        .removeClass('nav-outside')
        .each(function () {
          var $dd = $(this);
          // Guard against detached nodes
          var off = $dd.offset();
          if (!off) return;
          if (off.left + $dd.outerWidth() > viewport) {
            $dd.addClass('nav-outside');
          }
        });
    }

    function whenReady(fn) {
      var tries = 0, max = 40;
      (function tick() {
        var ready = $('#AccessibleNav').length;
        if (ready) { fn(); return; }
        if (++tries >= max) return;
        setTimeout(tick, 100);
      })();
    }

    $(function () { whenReady(updateDropdownOffsets); });

    $(window).on('load resize orientationchange', function () {
      setTimeout(updateDropdownOffsets, 0);
    });

    // Re-run in Theme Editor when sections reload
    $(document).on('shopify:section:load', function () {
      setTimeout(updateDropdownOffsets, 0);
    });
  })();
})();